export interface VivelaResponse<T> {
  data: T;
}
